import { z } from 'zod'

const DistributionBaseSchema = z.object({
  name: z.string(),
  allocation: z.number(),
  student_count: z.number(),
  amount_per_student: z.number(),
})

const GradeDistributionSchema = DistributionBaseSchema.extend({
  global_grade_level_id: z.number(),
})

const EducationDistributionSchema = DistributionBaseSchema.extend({
  education_type_id: z.number(),
  education_type_code: z.string(),
})

const FixedDistributionSchema = DistributionBaseSchema

const DistributionCategorySchema = z.union([
  GradeDistributionSchema,
  EducationDistributionSchema,
  FixedDistributionSchema,
])

// Schema for the summary object
const DistributionSummarySchema = z.object({
  distributions_by_category: z.array(DistributionCategorySchema),
})

const DistributionSelectionWarningsSchema = z.object({
  duplicates: z.record(z.string(), z.array(z.number())),
  missing_purse_eligibility: z.record(
    z.string(),
    z.object({
      name: z.string().nullable(),
    })
  ),
  sequence_gaps: z.record(z.string(), z.array(z.number())).optional(),
})

// Main distribution plan schema
const DistributionPlanSchema = z.object({
  total_amount: z.number(),
  total_students: z.number(),
  summary: DistributionSummarySchema,
  program_purse_id: z.number(),
  available_balance: z.number(),
  program_id: z.number(),
  has_warnings: z.boolean(),
  has_duplicate_warning: z.boolean(),
  warnings: DistributionSelectionWarningsSchema.nullable().optional(),
})

// Type inference
type DistributionPlan = z.infer<typeof DistributionPlanSchema>
type DistributionCategory = z.infer<typeof DistributionCategorySchema>
type DistributionSummary = z.infer<typeof DistributionSummarySchema>
type DistributionSelectionWarnings = z.infer<
  typeof DistributionSelectionWarningsSchema
>

// Export the schemas and types
export {
  DistributionPlanSchema,
  DistributionCategorySchema,
  DistributionSummarySchema,
  type DistributionPlan,
  type DistributionCategory,
  type DistributionSummary,
  type DistributionSelectionWarnings,
}

// Example usage:
// const validatedData = DistributionPlanSchema.parse(yourJsonData);
